import React from 'react';
import * as LuIcons from 'react-icons/lu';
import * as FaIcons from 'react-icons/fa';

/**
 * DynamicIcon renders an icon from react-icons based on a string name.
 * It prioritizes Lucide (Lu) but falls back to FontAwesome (Fa) for backward compatibility.
 * 
 * @param {string} name - The name of the icon (e.g. "Baby", "fa-broom")
 * @param {object} props - Standard SVG props (size, color, className)
 */
const DynamicIcon = ({ name, ...props }) => {
  if (!name) return null;

  // 1. Handle legacy FontAwesome strings (e.g. "fa-broom")
  if (name.startsWith('fa-')) {
    const iconName = name
      .split('-')
      .slice(1)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
    
    const FaIcon = FaIcons[`Fa${iconName}`];
    if (FaIcon) return <FaIcon {...props} />;
  }

  // 2. Handle modern Lucide names (e.g. "Baby", "Sparkles")
  // We check for "LuBaby" pattern
  const LuIcon = LuIcons[`Lu${name}`] || LuIcons[name];
  if (LuIcon) return <LuIcon {...props} />;

  // 3. Fallback to a default icon if not found
  const DefaultIcon = LuIcons.LuPackage;
  return <DefaultIcon {...props} />;
};

export default DynamicIcon;
